module.exports = __webpack_public_path__ + "img/10.fc621eb7.gif";